// src/pages/About.jsx
export default function About() {
  return (
    <main className="min-h-screen bg-white">
      {/* Hero */}
      <section className="bg-[#F7F3EC]">
        <div className="max-w-screen-2xl mx-auto px-6 py-16">
          <h1 className="text-3xl md:text-5xl font-extrabold tracking-tight text-[#0A2540]">
            About MassTortPlaintiffs
          </h1>
          <p className="mt-3 text-[#0A2540]/80 max-w-2xl">
            We help injured consumers understand their options and match with
            vetted mass-tort teams. Fast, private reviews and clear next
            steps—no pressure, no upfront costs.
          </p>
        </div>
      </section>

      {/* Mission + Quick facts */}
      <section className="py-14">
        <div className="max-w-screen-2xl mx-auto px-6 grid md:grid-cols-3 gap-8">
          <div className="md:col-span-2">
            <h2 className="text-2xl md:text-3xl font-semibold tracking-tight text-[#0A2540]">
              Our Mission
            </h2>
            <p className="mt-3 text-[#0A2540]/80 leading-7">
              Lawsuits can be complex. Our job is to simplify the path: explain
              eligibility, connect you with trusted partner firms, and help you
              move forward with clarity. Every review is confidential and takes
              just minutes to start.
            </p>
          </div>
          <div className="bg-white rounded-2xl ring-1 ring-black/10 p-6">
            <h3 className="font-semibold text-[#0A2540]">
              Why people choose us
            </h3>
            <ul className="mt-3 space-y-2">
              {[
                "Nationwide partner firms",
                "No upfront fees",
                "Fast, confidential reviews",
                "Plain-language updates",
              ].map((t) => (
                <li key={t} className="flex items-start gap-2">
                  <span className="mt-2 h-1.5 w-1.5 rounded-full bg-[#C89B3C]" />
                  <span className="text-sm leading-6 text-[#0A2540]/80">
                    {t}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      {/* Content Team (sample bios adapted from your references) */}
      <section className="py-14 bg-[#FBF9F4]">
        <div className="max-w-screen-2xl mx-auto px-6">
          <h2 className="text-2xl md:text-3xl font-semibold tracking-tight text-[#0A2540]">
            About the MassTortPlaintiffs Content Team
          </h2>
          <p className="mt-2 text-[#0A2540]/75">
            Our writers and editors focus on clarity and accuracy so you can
            make informed decisions.
          </p>

          <div className="mt-8 grid sm:grid-cols-2 gap-6">
            {/* Richard Summers */}
            <article className="rounded-2xl bg-white ring-1 ring-black/10 p-6">
              <h3 className="text-xl font-semibold text-[#0A2540]">
                Richard Summers
              </h3>
              <p className="mt-1 text-sm text-[#0A2540]/70">Content Manager</p>
              <p className="mt-3 text-sm text-[#0A2540]/80 leading-6">
                Richard oversees editorial at MassTortPlaintiffs and focuses on
                empowering consumers by explaining product liability and
                deceptive-marketing issues in plain language. With a background
                in education and content leadership, he’s led teams across
                legal-news and consumer-advocacy publications.
              </p>
              <p className="mt-2 text-xs text-[#0A2540]/60">
                Off the page: rewatching favorite series, bargain hunts, and
                exploring San Diego with her daughter.
              </p>
            </article>

            {/* Francis Holt */}
            <article className="rounded-2xl bg-white ring-1 ring-black/10 p-6">
              <h3 className="text-xl font-semibold text-[#0A2540]">
                Francis Holt
              </h3>
              <p className="mt-1 text-sm text-[#0A2540]/70">Senior Writer</p>
              <p className="mt-3 text-sm text-[#0A2540]/80 leading-6">
                Francis has reported across three continents, with bylines in
                national and niche outlets. He brings a reporter’s rigor to
                mass-tort topics—connecting complex developments to everyday
                impact.
              </p>
              <p className="mt-2 text-xs text-[#0A2540]/60">
                When not writing: soccer, neighborhood runs, and DIY-ing thrift
                finds.
              </p>
            </article>
          </div>
        </div>
      </section>

      {/* Compliance / who we are */}
      <section className="py-14">
        <div className="max-w-screen-2xl mx-auto px-6 grid md:grid-cols-2 gap-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-semibold tracking-tight text-[#0A2540]">
              How We Work
            </h2>
            <ul className="mt-4 space-y-2">
              {[
                "1) Check eligibility in minutes",
                "2) Get a private, no-obligation review",
                "3) Connect with a partner law firm",
                "4) Decide next steps with clear guidance",
              ].map((t) => (
                <li key={t} className="flex items-start gap-2">
                  <span className="mt-2 h-1.5 w-1.5 rounded-full bg-[#C89B3C]" />
                  <span className="text-sm leading-6 text-[#0A2540]/80">
                    {t}
                  </span>
                </li>
              ))}
            </ul>
          </div>
          <div className="bg-white rounded-2xl ring-1 ring-black/10 p-6">
            <h3 className="font-semibold text-[#0A2540]">Important Notes</h3>
            <p className="mt-2 text-sm text-[#0A2540]/80">
              MassTortPlaintiffs is not a law firm. We connect users with
              independent, licensed attorneys. Submitting information does not
              create an attorney-client relationship. Partner firms determine
              eligibility and representation.
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-14">
        <div className="max-w-screen-2xl mx-auto px-6">
          <a
            href="/contact"
            className="inline-flex items-center rounded-full px-6 py-3 font-semibold text-white bg-[#C89B3C] hover:bg-[#B8872D] transition"
          >
            Contact a Case Specialist
          </a>
        </div>
      </section>
    </main>
  );
}
